'use client';

import { useRouter } from 'next/navigation';
import { usePathname } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import i18nConfig from '@/i18nConfig';
import { FormControl, MenuItem, Select } from '@mui/material';

export default function LanguageChanger() {

	const { i18n } = useTranslation();
	const currentLocale = i18n.language;
	const router = useRouter();
	const currentPathname = usePathname();

	const handleChange = (e: { target: { value: string; }; }) => {
		const newLocale = e.target.value;

		// set cookie for next-i18n-router
		const days = 30;
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		const expires = date.toUTCString();
		document.cookie = `NEXT_LOCALE=${newLocale};expires=${expires};path=/`;

		// redirect to the new locale path
		if (
			currentLocale === i18nConfig.defaultLocale &&
			!i18nConfig.prefixDefault
		) {
			router.push('/' + newLocale + currentPathname);
		} else {
			router.push(
				currentPathname.replace(`/${currentLocale}`, `/${newLocale}`)
			);
		}

		router.refresh();
	};

	return (
		<FormControl variant="outlined" size="small" sx={{ minWidth: 136 }}>
			<Select
				onChange={handleChange}
				value={currentLocale}
				sx={{
					color: "text.secondary",
					"& .MuiOutlinedInput-notchedOutline": {
						borderColor: "transparent",
					},
					"&:hover .MuiOutlinedInput-notchedOutline": {
						borderColor: "divider",
					},
					"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
						borderColor: "divider",
					},
					"& .MuiSelect-select": {
						py: 0.5,
						fontSize: "0.9rem",
					},
				}}
			>
				<MenuItem value={"ar"}>العربية</MenuItem>
				<MenuItem value={"de"}>Deutsch</MenuItem>
				<MenuItem value={"en"}>English</MenuItem>
				<MenuItem value={"es"}>Español</MenuItem>
				<MenuItem value={"fa"}>فارسی</MenuItem>
				<MenuItem value={"fj"}>Na vosa vaka-Viti</MenuItem>
				<MenuItem value={"fr"}>Français</MenuItem>
				<MenuItem value={"ms"}>Melayu</MenuItem>
				<MenuItem value={"ta"}>தமிழ்</MenuItem>
				<MenuItem value={"zh"}>中文</MenuItem>
			</Select>
		</FormControl>
	);
}
